export interface QuarterFilterType {
  quarter: moment.Moment;
}

export const initialQuarterFilter: QuarterFilterType = {
  quarter: undefined,
};
